import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";

const Hero = () => {
    const navigate = useNavigate()
    const { t } = useLanguage()

    return (
        <div className="hero_cont fade-in">
            <h1 className="hero_title">{t.hero.title}</h1>
            <h2 className="hero_subtitle" dangerouslySetInnerHTML={{ __html: `${t.hero.desc}` }}></h2>
            {/* <div className="call_to_action_cont">
                <button className="call_to_action_btn" onClick={() => navigate("/join-waitlist")}>{t.items.waitlist_btn}</button>
            </div> */}
        </div>
    )
}

export default Hero